import { v4 as uuidv4 } from 'uuid';

export function RatingSummary(props) {
	return {
		componentName: 'RatingSummary',
		componentId: uuidv4(),
		draggableType: 'Container',
		droppableType: 'NONE',
		props: {
			...props,
		},
		childrenComponents: [],
	};
}
